





























import { Vue, Component } from 'vue-property-decorator';
import { List, Swipe, SwipeItem } from 'vant';
import NewsItem from '@/components/News/NewsItem .vue';
import { getNews, getGold, getNewsList } from '../api';
import Swiper from 'swiper';
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  imageList:any = {};
  newsList: any = [];
  swiperOption: any = {
    spaceBetween: 270,
    slidesPerView: 2, // 一屏显示的slide个数
    centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
    slideToClickedSlide: true, // 点击的slide会居中
    loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  }

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }

  async getGolds() {
    const ret:any = await getGold();
    console.log(ret);
    this.imageList = ret.data
  }

  async getNews(){
    // const res = await getNews(this.page, '全部', '9803');//9657
    const data = {
      page: this.page,
      pageSize: 10,
      columnId: 1053,
    };
    const res = await getNewsList(data);
    this.newsList = res.data.list.splice(0, 4);
  }

  async created () {
    this.getGolds();
    this.getNews();
  }

}
